import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { JobTitlesDataService } from "../../core/jobtitles.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-jobtitle",
    template: require('../shared/edit-view.html')
})
export class EditJobTitle extends EditBase<Nema.Crew.Model.JobType> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('jobTitle') entity: Nema.Crew.Model.JobType,
        @Inject(JobTitlesDataService.Id) jobTitleDataService: JobTitlesDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, jobTitleDataService, $log, isNew);
    }

    public entityDisplayName = "Job Title";

    public listStateName = "app.settings.jobtitles";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobtitles/jobtitle.edit.component.ts